var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrimeiraPagina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.348,
    height: 15.038,
    viewBox: "0 0 14.348 15.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8428",
    "data-name": "Grupo 8428",
    transform: "translate(-388.172 -875.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "selector",
    d: "M0,6.1,6.1,0l6.1,6.1",
    transform: "translate(395 889.07) rotate(-90)",
    fill: "none",
    stroke: "#DCE1E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3515",
    "data-name": "Ret\\xE2ngulo 3515",
    width: 2.47,
    height: 14.822,
    rx: 1.235,
    transform: "translate(388.172 875.589)",
    fill: "#DCE1E5"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeiraPagina);
export default __webpack_public_path__ + "static/media/primeira_pagina.076e5933.svg";
export { ForwardRef as ReactComponent };